import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "asset",
  "use": "asset-usage",
  "viewBox": "0 0 51.71 57.32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 51.71 57.32\" id=\"asset\"><path class=\"a\" d=\"M11.11 24.19a13 13 0 0113-13V.09A24.25 24.25 0 007.06 7a23.44 23.44 0 000 33.53l17 16.76V37.18a13 13 0 01-12.95-12.99z\" /><path class=\"b\" d=\"M26.66 36.55v.25a7.75 7.75 0 00.83-.21z\" /><path class=\"a\" d=\"M35.68 17.52L43.92 14A24.16 24.16 0 0027 .52v10.63a13.12 13.12 0 018.68 6.37zM27 36.75v11a24.14 24.14 0 0017.9-15.97l-8.63-2.58A13.1 13.1 0 0127 36.75zM37.17 26.2l13.71 4.11a23.67 23.67 0 00-.81-14.87L37 21a12.67 12.67 0 01.36 3 12.81 12.81 0 01-.19 2.2z\" /><path class=\"b\" d=\"M27 0h-2.9v.1a22.7 22.7 0 012.9.42z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/asset.svg
// module id = sxCb
// module chunks = 1